import { timestampToDateString, timestampToISOString, timestampToTimeString, } from './timestampToString';
export const LogFormat = {
    Raw: 'raw',
    Pretty: 'pretty',
};
export const logToString = (log, format = LogFormat.Raw) => {
    switch (format) {
        case LogFormat.Raw: {
            const dateTime = timestampToISOString(log.timestamp);
            const logLevel = log.level.charAt(0).toUpperCase();
            return `${dateTime} | ${logLevel} | ${log.message}`;
        }
        case LogFormat.Pretty: {
            const date = timestampToDateString(log.timestamp);
            const time = timestampToTimeString(log.timestamp);
            return `[${date} | ${time}] ${log.message}`;
        }
    }
};
export const logsToString = (logs, format = LogFormat.Raw) => logs.map((log) => logToString(log, format)).join('\n');
